export default {
  id: 25,
  title: 'Target #25 - Blossom',
  url: 'https://cssbattle.dev/play/25',
  colors: ['#998235', '#1A4341', '#F3AC3C'],
  solution:
    '<a a><a b><a c><a d><style>body{background:#998235}a{position:fixed;width:80}a[a],a[b]{background:#1a4341;height:100}[c],a[a]{left:110;border-radius:0 50px}[d],a[a]{top:60}[c],a[b]{bottom:60}[d],a[b]{right:110;border-radius:50px 0}a[c],a[d]{background:#f3ac3c;height:60}</style>',
}
